import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

interface ConfirmarCambiosSinGuardarDialogProps {
  open: boolean;
  guardando: boolean;
  onCancelar: () => void;
  onContinuarSinGuardar: () => void;
  onGuardarYContinuar: () => void;
}

export const ConfirmarCambiosSinGuardarDialog = ({
  open,
  guardando,
  onCancelar,
  onContinuarSinGuardar,
  onGuardarYContinuar
}: ConfirmarCambiosSinGuardarDialogProps) => {
  return (
    <Dialog open={open} onClose={onCancelar} fullWidth maxWidth="xs">
      <DialogTitle>Tiene cambios sin guardar</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Hay cambios sin guardar en la Matriz de Límites y Condiciones. Si continúa sin guardarlos, se van a perder.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="text" color="primary" onClick={onCancelar} disabled={guardando}>
          Cancelar
        </Button>
        <Button variant="outlined" color="error" onClick={onContinuarSinGuardar} disabled={guardando}>
          Continuar sin guardar
        </Button>
        <Button variant="contained" color="primary" onClick={onGuardarYContinuar} disabled={guardando}>
          Guardar y continuar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
